import { Flex, Box, Text } from "@chakra-ui/layout";
import { Heading } from "@chakra-ui/react";
import { Modal } from "antd";
import PrimaryButton from "components/Button/PrimaryButton";
import { ClienteContrato, TipoContrato } from "core/features/cliente/typings";
import ContentDetalhesContrato from "./ContentDetalhesContrato";
import { formatMoney } from "infra/helpers/number";

interface ModalContratoProps {
  item: ClienteContrato;
  isOpenModal: boolean;
  onClose: () => any;
}

export function ModalContrato({
  item,
  isOpenModal,
  onClose,
}: ModalContratoProps) {
  return (
    <>
      <Modal
        centered
        destroyOnClose
        width="1000px"
        footer={
          <Flex flex={1} justifyContent="end" gap={4}>
            <PrimaryButton onClick={onClose}>Fechar</PrimaryButton>
          </Flex>
        }
        visible={isOpenModal}
        onCancel={onClose}
      >
        <Box mb={4}>
          <Heading size="md">
            {item.tipoContrato === TipoContrato.Aluguel
              ? "Locação: "
              : "Venda: "}
            {`Imóvel ${item.matricula}`}
          </Heading>
          <Text>{`${formatMoney(item?.valor)}/mês` || "--"}</Text>
        </Box>

        <ContentDetalhesContrato item={item} />
      </Modal>
    </>
  );
}
